module.exports = __webpack_public_path__ + "img/dark-mode-desktop.e0d9c242.svg";